<template>
	<div class="pdf-wrap">
		<st-header
			:close-able="true"
			:back-able="true"
		></st-header>
		<div class="main">
			<div style="height: 100%;">
				<!-- <iframe :src="url" frameborder="0" style="width:100%;height: calc(100vh - 40px);"></iframe> -->
			</div>
		</div>
	</div>
</template>

<script>
import stHeader from "@/components/layout/Header.vue";
export default {
  components: {
		'st-header': stHeader,
	},
  props: {
	
	},
  data() {
    return {
			url: '',
		};
  },
  watch: {},

  methods: {
    init() {
			this.url = decodeURIComponent(this.$route.params.url);
			this.url = 'https://f9s3e.pmspte.com/FO-HKPMS-2405-0809-5110-2542.pdf'
			window.location = this.url;
		},
  },
  created() {
    this.init();
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
	.pdf-wrap {
		width: 100%;
		position: fixed;
		top: 0px;
		z-index: 100;
		
		.main {
			height: 100%;
			width: 100%;
		}
	}
</style>